import { useQuery } from "@tanstack/react-query";
import { getRegions } from "@src/entities/requestHH/api/requests/getRegions";
import { REQUEST_HH_QUERY_KEYS } from "../../constants";

export const useGetRegions = () => {
  const query = useQuery({
    queryKey: [REQUEST_HH_QUERY_KEYS.getRegions],
    queryFn: () => getRegions(),
  });

  return query;
};
